import React from 'react';

interface AppLogoutButtonProps {
  email: string;
  onLogout: () => void | Promise<void>;
}

const emailLocalPart = (email: string): string => {
  const at = email.indexOf('@');
  return at > 0 ? email.slice(0, at) : email;
};

const LogoutIcon = () => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const AppLogoutButton: React.FC<AppLogoutButtonProps> = ({ email, onLogout }) => {
  const displayName = emailLocalPart(email);

  return (
    <button
      type="button"
      className="app-header-logout-btn"
      onClick={() => {
        void onLogout();
      }}
      aria-label={`Log out (${email})`}
    >
      <span className="app-header-logout-icon">
        <LogoutIcon />
      </span>
      <span className="app-header-logout-label">{displayName}</span>
    </button>
  );
};

export default AppLogoutButton;
